// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1PWfn","label":"Radio_label__2HDlz","checkMark":"Radio_checkMark__1RbQV","disabled":"Radio_disabled__2vej2"};